import React from 'react';
import Linker from '../linker/Linker';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import './ReNavigationBar.css';

const ModalPrepare = (props) => {
  return (
    <Modal style={{ zIndex: '90000' }} show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          간편 리포트
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        간편 리포트 페이지는 현재 준비중입니다.<br />
        감사합니다.
      </Modal.Body>
      <Modal.Footer>
        <a className="button purple" onClick={props.handleClose}>닫기</a>
      </Modal.Footer>
    </Modal>
  )
}

const ReNavigationBar = (props) => {
  const path = props.path;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <div>
      <div className="nav">
        <nav id="topMenu">
          <ul>
            <li className="topMenuLi">
              <Linker path={path.HOME}>
                <a className="menuLink" >HOME</a>
              </Linker>
            </li>
            {/* {props.currentRole == 'ROLE_ADMIN' ?
              <li className="topMenuLi">
                <Linker path={path.QUICK}>
                  <a className="menuLink" >간편 리포트</a>
                </Linker>
              </li>
              :<li className="topMenuLi">
                <a className="menuLink" style={{cursor:'pointer'}} onClick={handleShow}>간편 리포트</a>
                <ModalPrepare show={show} handleClose={handleClose} />
              </li>
            } */}
            <li className="topMenuLi">
              <Linker path={path.QUICK}>
                <a className="menuLink" >간편 리포트</a>
              </Linker>
            </li>
            <li className="topMenuLi"><a className="menuLink">검색어 설정</a>
              <ul className="submenu">
                <li>
                  <Linker path={path.QUERYCREATE}>
                    <a className="submenuLink">검색어 만들기</a>
                  </Linker>
                </li>
                <li>
                  <Linker path={path.QUERYMANAGER}>
                    <a className="submenuLink">검색어 관리</a>
                  </Linker>
                </li>
              </ul>
            </li>
            <li className="topMenuLi"><a className="menuLink">상세리포트</a>
              <ul className="submenu">
                <li>
                  <Linker path={path.REPORTCREATE}>
                    <a className="submenuLink">리포트 만들기</a>
                  </Linker>
                </li>
                <li>
                  <Linker path={path.REPORTMANAGER}>
                    <a className="submenuLink">리포트 관리</a>
                  </Linker>
                </li>
                {/* <li>
                  <Linker path={path.CUSTOMREPORTCREATE} >
                    <a className="submenuLink">커스텀 리포트</a>
                  </Linker>
                </li>
                <li>
                  <Linker path={path.CUSTOMREPORTMANAGER}>
                    <a className="submenuLink">커스텀 리포트 관리</a>
                  </Linker>
                </li> */}
              </ul>
            </li>
            {
              props.currentRole == 'ROLE_ADMIN' ?
                <li className="topMenuLi"><a className="menuLink">트렌드 검색</a>
                  <ul className="submenu">
                    <li>
                      <Linker path={path.TRENDVOLUME}>
                        <a className="submenuLink" >검색량</a>
                      </Linker>
                    </li>
                    <li>
                      <Linker path={path.TRENDDETAIL}>
                        <a className="submenuLink" >상세분석</a>
                      </Linker>
                    </li>
                  </ul>
                </li>
                : undefined
            }
            <li className="topMenuLi"><a className="menuLink">스냅샷</a>
              <ul className="submenu">
                <li>
                  <Linker path={path.SNAPSHOTCREATE}>
                    <a className="submenuLink" >스냅샷 만들기</a>
                  </Linker>
                </li>
                <li>
                  <Linker path={path.SNAPSHOTMANAGER}>
                    <a className="submenuLink" >스냅샷 관리</a>
                  </Linker>
                </li>
              </ul>
            </li>
            <li className="topMenuLi">
              <Linker path={path.LABELMANAGER} >
                <a className="menuLink" >그룹 관리</a>
              </Linker>
            </li>
            {/* <li className="topMenuLi">
              <Linker path={path.INSIGHT} >
                <a className="menuLink" >인사이트</a>
              </Linker>
            </li> */}
            <li className="topMenuLi">
              <Linker path={path.NOTICE}>
                <a className="menuLink" >공지사항</a>
              </Linker>
            </li>
            {
              props.currentRole == 'ROLE_ADMIN' ?
                <li className="topMenuLi">
                  <Linker path={path.ADMIN}>
                    <a className="menuLink" >ADMIN</a>
                  </Linker>
                </li>
                : undefined
            }
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default ReNavigationBar;
